import Layout from '../../internal/Layout.vue'
import page from './index.vue'

const indexRoutes = {
  component: Layout,
  children: [
    {
      name: 'tecnovigilancia',
      path: '/',
      component: page,
      meta: {
        module: 'relatorios',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default indexRoutes
